<template>
    <div class="app-dashboard">

        <br>

        <mu-consumption-by type="provider"></mu-consumption-by>

        <br>

        <mu-row gutter>
            <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                <!-- Disparo Rapido -->
                <mu-sms-shooting></mu-sms-shooting>
            </mu-col>
            <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                <div class="totais">
                    <div class="date-filter">
                        <label>Filtre por mês:</label>
                        <select v-model="month" @change="loadSendsReceiveds()">
                            <option v-for="(item, key) in months" :key="key" :value="item">{{ getMonth(item) }}</option>
                        </select>
                        <select v-model="year" @change="loadSendsReceiveds()">
                            <option v-for="(item, key) in years" :key="key" :value="item">{{ item }}</option>
                        </select>
                        <button type="button" @click="loadSendsReceiveds()">Ok</button>
                    </div>
                    <br>
                    <mu-row v-if="!dashboard.loading">
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <div class="total-sends">
                                <h2>SMS Enviado</h2>
                                <h1>{{ dashboard.data.totalSends }}</h1>
                            </div>
                        </mu-col>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <div class="total-receiveds">
                                <h2>SMS Recebido</h2>
                                <h1>{{ dashboard.data.totalReceiveds }}</h1>
                            </div>
                        </mu-col>
                        <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                            <div class="total-receiveds">
                                <h2>TTS</h2>
                                <h1>{{ dashboard.data.totalTTS }}</h1>
                            </div>
                        </mu-col>
                    </mu-row>
                    <mu-loading text="Carregando dados" v-else></mu-loading>
                </div>
            </mu-col>
            <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                <!-- Balance -->
                <mu-my-balance title="Saldo dos serviços contratados" icon="attach_money"></mu-my-balance>
            </mu-col>
        </mu-row>
    </div>
</template>

<script>
    import SendsReceivedsServices from '@/services/dashboards/sendsreceiveds'

    export default {
        name: 'app-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                dashboard: {
                    loading: false,
                    data: {}
                },
                months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                years: [],
                month: 0,
                year: 0
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        async created () {
            let date = new Date()
            this.month = date.getMonth() + 1
            this.year = date.getFullYear()
            for (let index = 2019; index <= this.year; index++) {
                this.years.push(index)
            }
            await this.loadSendsReceiveds()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a lista de grupos passando a paginação
             */
            async loadSendsReceiveds () {
                try {
                    this.dashboard.loading = true

                    let data = {
                        month: this.month,
                        year: this.year
                    }

                    let result = await SendsReceivedsServices.total(data)

                    if (result && result.status) {
                        this.dashboard.data = result.results
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados do dashboard.')
                } finally {
                    this.dashboard.loading = false
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .app-dashboard

        .date-filter
            padding 10px
            background lighten($grey, 80%)
            text-align center
            label
                font-size 13px
                padding 8px 4px 8px 0
            select
                padding 8px
                margin-right 6px
                border 1px #ccc solid
                border-radius 2px
                color $grey
            button
                padding 8px
                border 0
                border-radius 2px
                background $grey
                color #fff
                cursor pointer

        .totais
            padding-bottom 15px
            border-radius 5px
            background lighten($grey, 90%)
            border 1px lighten($grey, 70%) solid
            p, h1, h2
                margin 4px 0
                padding 0
            h1
                font-size 40px
                line-height 40px
            h2
                font-size 14px
                margin 0
            svg
                font-size 20px
                margin-right 4px
            .total-sends, .total-receiveds
                max-width 280px
            .total-sends
                text-align center
                h1, h2, svg
                    color $color-blue
            .total-receiveds
                text-align center
                h1, h2, svg
                    color $color-blue

</style>
